import RootState from 'store/state';
import { useSelector } from 'react-redux';

export default function useCall(defaultState?: object): RootState["call"] {

    const call = useSelector<RootState, RootState["call"]>(
        ({ call }) => call ?? defaultState
    )

    return call
}
